import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const Loading = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ marginTop: '1em' }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loading;
